import bem from '../../../../utils/bem';

const Input = ({
  mods,
  id,
  name,
  type = 'checkbox',
  children,
  base,
  extraLabel,
  extraInput,
  innerRef,
  onChange,
  ...props
}) => {
  return (
    <label htmlFor={id} className={bem('label', mods, base, extraLabel)}>
      <input
        id={id}
        name={name}
        type={type}
        className={bem(type, mods, base, extraInput)}
        ref={innerRef}
        onChange={onChange}
        {...props}
      />
      <span className={`input-${type}__children`}>{children}</span>
    </label>
  );
};

export default Input;
